import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M26.1201 2.39986C30.6101 4.50986 35.9501 10.9199 35.4601 26.7699C34.9801 42.6199 22.7201 63.1399 5.59009 58.8499C5.59009 58.8499 14.5201 57.6098 11.5001 45.3598C8.48006 33.1098 4.15009 20.0199 8.53009 10.3199C12.9301 0.619869 22.1801 0.549856 26.1201 2.39986Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M8.84009 58.9898C8.84009 58.9898 18.1101 57.4798 18.3101 46.9798C18.6501 29.3898 15.3301 10.4298 24.7001 3.5498C24.7001 3.5498 25.4101 6.98983 27.9001 22.6998C29.5501 33.1398 27.5701 56.7798 12.0801 59.0398"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M20.3401 3.63989C20.3401 3.63989 6.46015 7.3699 13.2802 35.4599C16.9002 50.3999 14.7701 56.8599 9.36011 58.3499"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M66.1702 2.39986C61.6802 4.50986 56.3402 10.9199 56.8302 26.7699C57.3102 42.6199 69.5702 63.1399 86.7002 58.8499C86.7002 58.8499 77.7702 57.6098 80.7902 45.3598C83.8102 33.1098 88.1402 20.0199 83.7602 10.3199C79.3602 0.619869 70.1102 0.549856 66.1702 2.39986Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M83.4503 58.9899C83.4503 58.9899 74.1803 57.4799 73.9803 46.9799C73.6403 29.3899 77.6603 10.5199 68.3003 3.63989C68.3003 3.63989 66.8803 6.98992 64.3903 22.6999C62.7403 33.1399 64.7203 56.7799 80.2103 59.0399"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M71.9502 3.63989C71.9502 3.63989 85.8302 7.3699 79.0102 35.4599C75.3902 50.3999 77.5202 56.8599 82.9302 58.3499"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
